/**
 * FEC Custom JS — Far East Chaos
 * Minimal, purposeful interactions only.
 * - Mobile sticky add-to-cart
 * - Social carousel scroll hint
 */

(function() {
  'use strict';

  /* === STICKY ADD TO CART (MOBILE) === */
  function initStickyATC() {
    var atcButton = document.querySelector('[data-testid="add-to-cart-button"], .product-form__submit, [name="add"]');
    if (!atcButton) return;

    var stickyBar = document.createElement('div');
    stickyBar.className = 'fec-sticky-atc';
    stickyBar.innerHTML =
      '<div class="fec-sticky-atc__info">' +
        '<div class="fec-sticky-atc__title"></div>' +
        '<div class="fec-sticky-atc__price"></div>' +
      '</div>' +
      '<button class="fec-sticky-atc__btn" type="button">Add to Cart</button>';
    document.body.appendChild(stickyBar);

    var titleEl = document.querySelector('.product-information h6, .product-information [data-product-title], .product__title');
    var priceEl = document.querySelector('.product-information .price, .product-information [data-product-price]');

    if (titleEl) stickyBar.querySelector('.fec-sticky-atc__title').textContent = titleEl.textContent.trim();
    if (priceEl) stickyBar.querySelector('.fec-sticky-atc__price').textContent = priceEl.textContent.trim();

    stickyBar.querySelector('.fec-sticky-atc__btn').addEventListener('click', function() {
      atcButton.click();
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });

    observer.observe(atcButton);

    if (priceEl) {
      new MutationObserver(function() {
        stickyBar.querySelector('.fec-sticky-atc__price').textContent = priceEl.textContent.trim();
      }).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
  }

  /* === SOCIAL CAROUSEL SCROLL HINT === */
  function initSocialCarousel() {
    document.querySelectorAll('.fec-social-carousel').forEach(function(carousel) {
      var scrolled = false;
      carousel.addEventListener('scroll', function() { scrolled = true; }, { once: true });

      setTimeout(function() {
        if (!scrolled && carousel.scrollWidth > carousel.clientWidth) {
          carousel.scrollBy({ left: 60, behavior: 'smooth' });
          setTimeout(function() {
            carousel.scrollBy({ left: -60, behavior: 'smooth' });
          }, 350);
        }
      }, 2500);
    });
  }

  /* === INIT === */
  function init() {
    if (window.matchMedia('(max-width: 749px)').matches) {
      initStickyATC();
    }
    initSocialCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
